<template>
  <div id="pMember">
    <Nav type="transparent" />
    <span class="pageTitle">会员服务</span>
    <div class="pContent" style="padding-bottom: 140px;">
      <div class="blockTit" style="margin-bottom: 48px;">会员特权及说明</div>
      <template v-for="(item, index) in memberData.cards">
        <div class="card clearfix">
          <div class="cardName flexBox">
            <img :src="require(`@/${item.icon}`)" alt />{{ item.name }} {{ item.price }}
          </div>
          <div class="cardInfo flexBox">
            <p>
              <strong>{{ item.basicRightsTitle || `基础权益` }}</strong>
            </p>
            <template v-for="right in item.basicRights">
              <p>·{{ right }}</p>
            </template>
            <p>&nbsp;</p>
            <template v-if="item.valueRights">
              <p>
                <strong>{{ item.valueRightsTitle || `增值权益` }}</strong>
              </p>
              <template v-for="right in item.valueRights">
                <p>·{{ right }}</p>
              </template>
            </template>
          </div>
        </div>
      </template>
      <div class="cardNote">
        *
        <template v-for="(note, index) in memberData.notes">
          <p>{{index + 1}} {{ note }}</p>
        </template>
        <mu-icon class="mIcon" size="16" value="info_outline" @click="table = true"></mu-icon>
      </div>
      <mu-dialog title class="table" width="800" :open.sync="table">
        <i class="close" @click="table = false"></i>
        <div class="imgBox">
          <!-- <img src="../assets/pageM.png" alt /> -->
          <mu-data-table stripe :columns="columns" :data="list" :fit="false">
            <template slot-scope="scope">
              <td>{{scope.row.name}}</td>
              <td>{{scope.row.time}}</td>
              <td>¥{{scope.row.price}}</td>
              <td>¥{{scope.row.l1Price}}</td>
              <td>¥{{scope.row.l2Price}}</td>
              <td>¥{{scope.row.l3Price}}</td>
            </template>
          </mu-data-table>
        </div>
      </mu-dialog>
    </div>
    <ToTop />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import ToTop from "@/components/ToTop.vue";
import memberData from "@/utils/member.js";
export default {
  name: "Member",
  data() {
    return {
      table: false,
      memberData: memberData,
      list: memberData.products,
      columns: [
        { title: "项目", width: 200, name: "name" },
        { title: "时长", width: 90, name: "time" },
        { title: "门市价", width: 110, name: "price" },
        { title: "VIP卡", width: 110, name: "l1Price" },
        { title: "明星卡", width: 110, name: "l2Price" },
        { title: "钻石卡", width: 110, name: "l3Price" }
      ]
    };
  },
  components: {
    Nav,
    ToTop
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
#pMember {
  padding: 350px 0 40px;
  background: url(../assets/pMember-banner.jpg) top/auto 350px no-repeat;

  .pContent {
    margin: 0 auto;
    // width: 1200px;
    // @media(width: 1024px){
    //     width: 980px;
    // }
    width: 90%;
    max-width: 1200px;
  }
  .blockTit {
    margin: 90px 0 60px;
  }
  .blockText {
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .card {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin: 24px auto 0;
    padding: 40px 28px 40px;
    width: 100%;
    background: #f8f9f8;

    .cardName {
      float: left;
      width: 46.33%;
      height: 100%;
      font-size: 18px;
      line-height: 1;
      color: #333;
      text-align: center;
      > img {
        display: block;
        margin: 0 auto 24px;
        width: 190px;
      }
    }
    .cardInfo {
      float: right;
      width: 53.66%;
      min-height: 180px;
      font-size: 16px;
      line-height: 28px;
      color: #555;
    }
  }
  .cardNote {
    margin: 16px 0 0 10px;
    font-size: 12px;
    line-height: 20px;
    color: #b0b0b0;
    p {
      display: inline-block;
      margin: 0 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }

  ol {
    padding-left: 20px;
    li {
      // display: block;
      list-style: decimal;
    }
  }

  .mIcon {
    position: relative;
    top: 3px;
    color: #d1d1d1;
    cursor: pointer;
  }

  .luckdraw {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      margin: 128px 0 38px;
      width: 686px;
    }
  }
}
</style>